<template>
  <div class="activities">
    <div class="title">
      <div></div>
      酒吧列表
    </div>
    <div class="query">
      <div class="query-box">
        <span>查询</span>
        <el-input v-model="query" placeholder="酒吧名称"></el-input>
      </div>
      <div class="query-box">
        <span>日期</span>
        <el-date-picker
          v-model="activityTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="querys"
        >
        </el-date-picker>
      </div>
 <div class="query-box">
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <el-button type="primary" @click="inquire">查询</el-button>
      <el-button type="primary" @click="addBar">新增</el-button>
        <el-button type="primary" @click="derive">导出</el-button>
         <el-button type="primary" @click="down">下载模板</el-button>
      <el-button type="primary" @click="toLead">导入</el-button>
    </div>
    <div class="activities-main">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" type="index" label="序号" width="50">
        </el-table-column>

        <el-table-column align="center" prop="id" label="酒吧Id">
        </el-table-column>
        <el-table-column align="center" prop="barName" label="酒吧名称">
        </el-table-column>
        <el-table-column align="center" prop="cityName" label="城市">
        </el-table-column>

        <el-table-column align="center" prop="detailedAddress" label="详细地址">
        </el-table-column>

        <el-table-column align="center" prop="businessHours" label="营业时间">
        </el-table-column>

        <el-table-column
          align="center"
          prop="featuresIntroduced"
          label="特点介绍"
        >
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.featuresIntroduced" placement="top">
              <p class="showOverTooltip">{{ scope.row.featuresIntroduced }}</p>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" label="评分">
          <template slot-scope="scope">
            <el-rate v-model="scope.row.meanNumber" disabled></el-rate>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="createTime" label="创建日期">
        </el-table-column>

          <el-table-column align="center" prop="isOff" label="状态">
              <template slot-scope="scope">
            <div
              :class="scope.row.isOff == 0? 'active2': 'active'"
            >
              {{
                scope.row.isOff == 0
                  ? "上架中"
                  : "已下架"
              }}
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" width="299">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="activity(scope.row.id)"
              >活动管理</el-button
            >

            <el-button
              size="mini"
              type="primary"
              @click="spotEdit(scope.row.id)"
              >编辑</el-button
            >
           <el-button
              v-if="scope.row.isOff == 1"
              size="mini"
              type="success"
              @click="isOff(scope.row.id, 0)"
              >上架</el-button
            >

            <el-button
              v-else
              size="mini"
              type="info"
              @click="isOff(scope.row.id, 1)"
              >下架</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="spotDelete(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
        <!-- 导入 -->
    <input
      ref="excel-upload-input"
      class="excel-upload-input"
      type="file"
      accept=".xlsx, .xls"
      @change="handleClick"
    />
  </div>
</template>

<script>
import moment from "moment";
import local from "@/utils/local.js";
import { webBarPage, baronOff,delBar,functiondownload ,batchImportBar} from "@/api/api";
export default {
  data() {
    return {
      ruleList: [],
      query: "",
      startTime: "",
      endTime: "",
      activityTime: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      adminId: "",
       value: "",
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "上架中",
        },
        {
          value: "1",
          label: "已下架",
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
       // 导入
    toLead() {
        console.log(111)
      this.$refs["excel-upload-input"].click();
    },
    async handleClick(e) {
      const files = e.target.files;
      const rawFile = files[0];
        var formData = new FormData()
        formData.append('file', rawFile)

      let { code, msg } = await batchImportBar(formData);
      if (code == 200) {
          this.$message({
              type: "success",
              message: "导入成功!",
            });
          this.getList();
       }
    },
    // 下载模板
    down() {
      // IMPORT_BAR_ICON 导入酒吧icon
      // BATCH_IMPORT_BAR 批量导入酒吧
      functiondownload(
        "/web/bar/downloadModel",
        {
          modelType: "BATCH_IMPORT_BAR",
        },
        true
      );
    },
       // 轮播上下架
    isOff(id, isOff) {
      this.$confirm(isOff == 0 ? "是否确定上架" : "是否确定下架", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await baronOff({
            id: id,
            isOff: isOff,
          });
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "编辑成功!",
            });
            this.getList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消编辑",
          });
        });
    },
   

       // 导出
    derive(){
       functiondownload('/web/bar/webBarPageExportExcel',{ query:this.query,startTime: this.startTime,
        endTime: this.endTime,type: 1, isOff:this.value},true)
    },
    activity(id) {
      this.$router.push("activityList?barId=" + id);
    },

    spotEdit(id) {
      this.$router.push("editBar?barId=" + id);
    },
    querys() {
      if (this.activityTime == null) {
        (this.startTime = ""), (this.endTime = "");
      }
    },
    //  获取酒吧列表
    async getList() {
      let res = await webBarPage({
        query: this.query,
        startTime: this.startTime,
        endTime: this.endTime,
        isOff:this.value,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
      });
      console.log(res);
      let { data } = res;
      //  边界判断
      if (!data.itemList.length && this.currentPage !== 1) {
        this.currentPage -= 1;
        this.getList();
      }
      data.itemList.forEach((item) => {
        item.businessHours = item.businessHours.split(",").join("-");
      });
      this.tableData = data.itemList;
      this.total = data.totalSize;
    },
    // 查询
    inquire() {
      if (this.activityTime) {
        (this.startTime = moment(this.activityTime[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        )),
          (this.endTime = moment(this.activityTime[1]).format(
            "YYYY-MM-DD HH:mm:ss"
          ));
      }

      this.getList();
    },
    // 刷新
    refresh() {
      this.query = "";
      this.startTime = "";
      this.endTime = "";
      this.activityTime = "";
      this.getList();
    },
    // 新增
    addBar() {
      this.$router.push("addBar");
    },
    // 删除
    spotDelete(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await delBar({
            barId: id,
          });
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //每页多少条
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    //当前多少页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>

.activities {
  // height: 100%;
  background: #fff;
  padding: 15px;
  color: #303133;
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    div {
      width: 3px;
      height: 16px;
      background: #409eff;
      margin-right: 10px;
    }
  }
  .query {
    margin: 15px 0 30px;
    display: flex;
    align-items: center;
    .query-box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .el-input {
        width: 260px;
      }
      span {
        width: 60px;
      }
    }
  }
  .activities-main {
    margin: 15px 0;
  }
  .paging {
    display: flex;
    justify-content: flex-end;
  }
  .showOverTooltip {
    display: -webkit-box;
    text-overflow: ellipsis;
    overflow: hidden;
    /*这里是3行*/
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
  .active {
  color: red;
}
.active2 {
  color: #33b959;
}
}
.excel-upload-input{
    position: relative;
    z-index: -1;
}
</style>